export default "__VITE_ASSET__osN4KiXO__"